// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"769":"854fc961","819":"71c62685"}[chunkId] + ".chunk.js";
};